<ion-card>
  <ion-card-header>
    <ion-card-title>Törzslap-határidő</ion-card-title>
    <ion-card-subtitle>
      „Az iskola a tanulókról – a tanévkezdést követő harminc napon belül – egyéni törzslapot állít ki.”
      ({{ adat?.jogalap || '20/2012. (VIII. 31.) EMMI rendelet 99. § (1)' }})
      A tanév közben felvett tanulónál a felvételtől számított 30 nap. A határidő előtt {{ adat?.elotte_nap || 7 }} nappal
      és a lejáratkor az adminisztrátorok és az iskolatitkár rendszerüzenetet kapnak.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <!-- A törzslap-sablon tartalmi ellenőrzése (20/2012. EMMI r. 99. § (3)) – backend/torzslap.js sablonHianyok.
         Csak jelzés: a generálás a régi sablonnal is megy, de a hiányzó elemek nem kerülnek a törzslapra. -->
    <div *ngIf="sablon" class="sablon-ellenorzes">
      <p *ngIf="!sablon.megvan" class="figyel-szoveg">
        <ion-icon name="warning-outline" color="warning" aria-hidden="true"></ion-icon>
        Nincs feltöltött törzslap-sablon (<code>sablonok/torzslap.docx</code>) – a törzslap addig nem generálható.
      </p>
      <p *ngIf="sablon.megvan && !sablon.olvashato" class="figyel-szoveg">
        <ion-icon name="warning-outline" color="warning" aria-hidden="true"></ion-icon>
        A törzslap-sablon nem olvasható Word-dokumentumként – a tartalma nem ellenőrizhető.
      </p>
      <p *ngIf="sablon.olvashato && sablon.hianyok.length" class="figyel-szoveg">
        <ion-icon name="warning-outline" color="warning" aria-hidden="true"></ion-icon>
        A törzslap-sablonból hiányzik ({{ sablon.jogalap }}): {{ hianyFelsorolas(sablon.hianyok) }}.
        A törzslap így is elkészül, de ezek az adatok nem kerülnek rá – tölts fel kiegészített sablont.
      </p>
      <p *ngIf="sablon.olvashato && !sablon.hianyok.length" class="halvany">
        A törzslap-sablon a {{ sablon.jogalap }} minden olyan elemét tartalmazza, amit a rendszer ki tud tölteni.
      </p>
      <p *ngIf="sablon.nincs_adat.length" class="halvany">
        A rendszer ma nem tárolja: {{ hianyFelsorolas(sablon.nincs_adat) }} – az érintett tanulóknál kézzel kell pótolni.
      </p>
    </div>

    <div *ngIf="!ev" class="halvany">Nincs kiválasztott tanév.</div>

    <div *ngIf="betolt" class="ion-text-center ion-padding">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <ng-container *ngIf="!betolt && adat">
      <p class="osszegzes">
        Tanév: <strong>{{ adat.tanev }}</strong> · tanévkezdés: {{ pontos(adat.tanevkezdes) }} ·
        határidő: <strong>{{ pontos(adat.alap_hatarido) }}</strong> · ma: {{ pontos(adat.ma) }}
      </p>
      <div class="szamlalok">
        <ion-chip color="medium" [outline]="true">Tanuló: {{ adat.darab.osszes }}</ion-chip>
        <ion-chip color="success">Kiállítva: {{ adat.darab.kiallitva }}</ion-chip>
        <ion-chip color="warning" *ngIf="adat.darab.kesve">Késve kiállítva: {{ adat.darab.kesve }}</ion-chip>
        <ion-chip [color]="adat.darab.hatra_7_napon_belul ? 'warning' : 'medium'" *ngIf="adat.darab.hatra">
          Még nincs, van idő: {{ adat.darab.hatra }}
        </ion-chip>
        <ion-chip color="danger" *ngIf="adat.darab.lejart">Lejárt, nincs törzslap: {{ adat.darab.lejart }}</ion-chip>
        <ion-chip color="medium" *ngIf="adat.darab.kilepett">A határidő előtt kilépett: {{ adat.darab.kilepett }}</ion-chip>
      </div>

      <ion-segment [(ngModel)]="szuro" class="szuro">
        <ion-segment-button value="hianyzik"><ion-label>Akiknek még nincs</ion-label></ion-segment-button>
        <ion-segment-button value="mind"><ion-label>Mindenki</ion-label></ion-segment-button>
      </ion-segment>

      <ion-note *ngIf="!csoportok.length" color="success" class="ures">
        {{ szuro === 'hianyzik' ? 'Minden tanulónak van erre a tanévre tárolt törzslapja.' : 'Nincs tanuló a tanév osztályaiban.' }}
      </ion-note>

      <div *ngFor="let cs of csoportok" class="osztaly">
        <div class="osztaly-fej">
          <strong>{{ cs.osztaly }}</strong>
          <span class="halvany">{{ cs.tanulok.length }} tanuló<ng-container *ngIf="cs.hianyzo.length"> · {{ cs.hianyzo.length }} hiányzik</ng-container></span>
          <ion-button *ngIf="cs.hianyzo.length" size="small" color="secondary" (click)="kiallit(cs)" [disabled]="fut[cs.osztaly_id]">
            <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
            {{ fut[cs.osztaly_id] ? 'Készül…' : 'Kiállítás a hiányzóknak (' + cs.hianyzo.length + ')' }}
          </ion-button>
        </div>
        <ion-list lines="full">
          <ion-item *ngFor="let t of cs.tanulok">
            <ion-label class="ion-text-wrap">
              <h3>{{ t.nev }}</h3>
              <p>
                Határidő: {{ pontos(t.hatarido) }}<ng-container *ngIf="t.hatarido_alapja === 'felvetel'"> (felvétel: {{ pontos(t.jogviszony_kezdete) }})</ng-container>
                <ng-container *ngIf="t.kiallitva"> · kiállítva: {{ pontos(t.kiallitva) }}</ng-container>
                <ng-container *ngIf="t.verzio > 1"> · utoljára: {{ pontos(t.utolso) }} ({{ t.verzio }}. változat)</ng-container>
                <ng-container *ngIf="t.iktatoszam"> · iktatószám: {{ t.iktatoszam }}</ng-container>
              </p>
            </ion-label>
            <ion-badge slot="end" [color]="szin(t)">{{ allapotSzoveg(t) }}</ion-badge>
            <ion-button slot="end" *ngIf="t.path" fill="clear" size="small" (click)="megnyit(t)" aria-label="Törzslap megnyitása">
              <ion-icon slot="icon-only" name="document-text-outline"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
      </div>

      <div class="ion-padding-top">
        <ion-button fill="outline" size="small" (click)="betoltes()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
        </ion-button>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
